<template lang="pug">

include ../../../pug/mixins/index

+b-context('calendar')
  +e.unit-wrap(:class=`{ 'is-hoverable': is.hoverable, 'is-product': is.product, 'is-group': is.group, 'is-empty': is.empty, 'is-active': selected.alternative || selected.product || selected.group }`, @mouseleave='deselect', @mouseenter='select(false)')
    +e.unit(:style=`{
        'background-color': is.group ? cell.product_group.preview_color : '#fbe2a9'
      }`): template(v-if='cell')
      +e.picture(@click.prevent.stop='select(true)')
        img(:src='cell.product.small_image', v-if='is.product')
        img(:src='cell.product_group.image', v-if='is.group')
        img(src='/static/images/qwestion.png', v-if='is.empty')
      +e.food(v-if='is.group', v-text='cell.product_group.name', @click.prevent.stop='select')
      +e.icon(:class!=`{ ['calendar__icon--' + reaction ]: typeof reaction !== 'undefined' }`)
      +e.hover(
        v-if='is.product',
        @click.stop=''
      )
        +e.icons
          a.calendar__icons--type.img(href="#", @click.prevent.stop=`confirmOpen('like')`, :class=`{ 'is-current': reaction == 1 }`)
            img(src="/static/images/ic1.png")
          a.calendar__icons--type.img(href="#", @click.prevent.stop=`confirmOpen('dislike')`, :class=`{ 'is-current': reaction == 2 }`)
            img(src="/static/images/ic2.png")
          a.calendar__icons--type.img(href="#", @click.prevent.stop=`confirmOpen('allergic')`, :class=`{ 'is-current': reaction == 3 }`)
            img(src="/static/images/ic3.png")

      +e.hover-half(
        v-if='is.product && selected.alternative',
        :class=`{ 'is-active': selected.alternative && (isLoading || alternatives.length > 0) }`,
        @click.stop=''
      )
        +e.hover-top
          loading(v-if='isLoading')
          +e.SLIDER.slider(:options!=`{
            prevButton: '.category__nav--prev',
            nextButton: '.category__nav--next',
          }`, v-else='')
            +e.SWIPER-SLIDE.slide(v-for='alternative in alternatives', :key='alternative.id')
              +e.img.img(@click.prevent='setProduct(alternative)')
                img(:src="alternative.small_image", style='max-height: 65px')

            +b.category__nav.--prev.icon-left(slot='button-next', v-show='alternatives.length > 0')
            +b.category__nav.--next.icon-right(slot='button-prev', v-show='alternatives.length > 0')
          //- +e.slider
            +e.slide
              +e.img.img
                img(src="/static/images/img.png")
            .category__nav.category__nav--prev.icon-left
            .category__nav.category__nav--next.icon-right

      .zoom(v-if='is.product && selected.alternative', :class=`{ 'is-active': selected.alternative }`, @click.stop='')
        .zoom__arrow
        //- .zoom__close.icon-close3
        //- .zoom__img-mini.img
          img(
            v-for='alternative in alternatives',
            @click.prevent='setProduct(alternative)'
            :src="alternative.small_image",
          )
        .zoom__block
          .zoom__picture.img
            img(:src='cell.product.small_image')
        .zoom__icons
          a.zoom__icon.zoom__icon--1(href="#", @click.prevent.stop=`confirmOpen('like')`, :class=`{ 'is-active': reaction === 1 }`)
          a.zoom__icon.zoom__icon--2(href="#", @click.prevent.stop=`confirmOpen('dislike')`, :class=`{ 'is-active': reaction === 2 }`)
          a.zoom__icon.zoom__icon--3(href="#", @click.prevent.stop=`confirmOpen('allergic')`, :class=`{ 'is-active': reaction === 3 }`)

      .half.half--products(
        v-if='selected.product',
        :class=`{ 'is-active': selected.product && (isLoading || variants.length > 0)}`,
        style="position: absolute; top: 100%; left: 50%; transform: translateX(-50%); z-index: 1000",
        @click.stop=''
      )
        .half__arrow
        //- .half__title Овощи
        .half__drop-slider
          loading(v-if='isLoading')
          div(:style="{ width: ((variants.length > 3 ? 3 : variants.length) * 75) + 'px'}", v-else='')
            +e.SLIDER.slider(:options!=`{
              slidesPerView: (variants.length > 3 ? 3 : variants.length),
              prevButton: '.category__nav--prev',
              nextButton: '.category__nav--next',
            }`)
              swiper-slide.half__drop-slide(v-for='variant in variants', :key='variant.id')
                .half__product.center(@click.prevent='setProduct(variant)')
                  img(:src="variant.small_image")
                .half__drop-name(v-text='variant.name')
                //- +e.img.img


                //- a(href="#", style="float: left; width: 60px")

              +b.half__nav.--prev.icon-left(slot='button-next', v-show='variants.length > 0')
              +b.half__nav.--next.icon-right(slot='button-prev', v-show='variants.length > 0')

          //- .owl-wrap(, v-else='')
          //-   - for (var x = 0; x < 3; x++)
          //- .half__nav.half__nav--prev.icon-left
          //- .half__nav.half__nav--next.icon-right

      .half.half--group(
        v-if='selected.group',
        :class=`{ 'is-active': selected.group && (isLoading || variants.length > 0)}`,
        style="position: absolute; top: 100%; left: 50%; transform: translateX(-50%); z-index: 1000",
        @click.stop=''
      )
        .half__arrow
        .half__group.clearfix
          loading(v-if='isLoading')
          a.half__group-block(
            v-for='group in variants',
            href="#", @click.prevent='setGroup(group)',
            v-else=''
          )
            .half__drop-picture.center(:style=`{ 'background-color': group.preview_color }`)
              img(:src='group.image')
            .half__drop-name(v-text='group.name')

    custom-modal(:title='confirmTitle', ref='confirm', v-if='is.product', :dismissible='false', @click.prevent.stop='')
      loading(v-if='isLoading')
      .modal__picture.img(v-else='')
        img(:src="cell.replaced_product ? (cell.replaced_product.large_image || cell.replaced_product.small_image) : (cell.product.large_image || cell.product.small_image)")
        .modal__icon(:class='confirmIcon')
      template(slot="footer")
        .modal__part
          button.calendar__link.modal__link2(:disabled='isLoading', @click.prevent='confirmSucceed()', v-text='i18n.yes')
          button.calendar__link.modal__link2(:disabled='isLoading', @click.prevent='confirmClose()', v-text='i18n.no')

    //- modal(:title='i18n.chooseReplaceAlternative', ref='replace', v-if='is.product', :dismissible='false', @click.prevent.stop='')
      loading(v-if='isLoading')
      .modal__picture.img(v-else='')
        img(:src="cell.product.large_image || cell.product.small_image")
        .modal__icon(:class='confirmIcon')
      template(slot="footer")
        .modal__part
          button.calendar__link.modal__link2(:disabled='isLoading', @click.prevent='confirmSucceed()', v-text='i18n.replace')
          button.calendar__link.modal__link2(:disabled='isLoading', @click.prevent='confirmClose()', v-text='i18n.no')

    custom-modal(ref='replaceAlternatives')
      +e.title.modal__title--2(v-text='variants.length == 0 && !isLoading ? i18n.noReplaceAlternative : i18n.chooseReplaceAlternative', ref='clickhunter')

      div(@click.prevent.stop='')
        loading(v-if='isLoading')
        div(v-else-if='variants.length > 0')
          +e.SLIDER.slider(:options!=`{
            slidesPerView: 4,
            prevButton: '.half__nav--prev',
            nextButton: '.half__nav--next',
          }`)
            swiper-slide(v-for='product in variants', :key='product.id')
              a.half__drop-slide(href="#", @click.prevent='setReplace(product.id)')
                .half__product.center(:class=`{ 'is-active': replace==product.id }`)
                  img(:src="product.small_image")
                .half__drop-name(v-text='product.name')

            .half__nav.half__nav--prev.icon-left(slot='button-next', v-show='variants.length > 0')
            .half__nav.half__nav--next.icon-right(slot='button-prev', v-show='variants.length > 0')

      br

      template(slot="footer")
        +e.part
          +e.BUTTON.link(style='margin-bottom: 0;', type='button', :disabled='isLoading', @click='variantConfirm()', v-text='variants.length > 0 && replace ? i18n.replace : i18n.remove')

    custom-modal(ref='loader', :dismissible='false')
      loading(slot='modalWindow')

          //- mixin group(gClass, gName)
          //- +group('half__drop-picture--lime', 'Овощи')
          //- +group('half__drop-picture--orange', 'Каши')
          //- +group('half__drop-picture--pink', 'Фрукты')
          //- +group('half__drop-picture--rose', 'Мясо')
          //- +group('half__drop-picture--brown', 'Хлеб')
          //- +group('half__drop-picture--yellow is-active', 'Молочные')

    //- +b.half--mobile
      +e.drop-slider.clearfix

        mixin dropslider(dType)
          +e.A.drop-slide(href="#")
            +e.drop-picture&attributes(attributes).center
              img(src="/static/images/pic5.png")
            +e.drop-name: +trans Фрукты

        +dropslider.half__drop-picture--lime
        +dropslider.half__drop-picture--orange
        +dropslider.half__drop-picture--pink
        +dropslider.half__drop-picture--rose

        +e.nav.--prev.icon-left
        +e.nav.--next.icon-right
    //- +b.zoom
      +e.close.icon-close3
      +e.img-mini.img
        img(src="/static/images/z1.png")
      +e.block
        +e.picture.img
          img(src="/static/images/z2.png")
      +e.icons
        +e.A.icon.icon--1.is-active(href="#")
        +e.A.icon.icon--2(href="#")
        +e.A.icon.icon--3(href="#")

  //- +e.wrapper
    +e.preview
      +e.image
      +e.icon(:class='iconClass', v-if='isReactioned')
      +e.title
    +e.actions
      +e.action

  //- +e.popup
    popup(ref='popup')
      loading(v-if='loading')
      +e.slider(v-else)
        slider(in='stage-cell')
          slider-item(v-for='variant in variants')
            +e.variant(
              @click.prevent='choose(variant)'
            )


</template>

<script>

import Loadable from '@shared/mixins/loadable'
import Translatable from '@shared/mixins/translatable'


export default {
  mixins: [Loadable, Translatable],
  inject: ['productsService', 'stagesService'],

  props: {
    cell: { },
    today: { type: Date, reqiured: true },
    isToday: { type: Boolean, reqiured: true },
    index: { type: Number },
    stage: { },
  },

  data() { return {
    is: {
      product: false,
      group: false,
      empty: false,
      hoverable: false,
    },

    selected: {
      alternative: false,
      product: false,
      group: false,
    },

    alternatives: [],
    variants: [],
    replace: null,

    confirmTitle: '',
    confirmIcon: 'modal__icon--1',
  } },

  created() {
    this.determineType()
  },

  mounted() {
    this.$nextTick(x => this.$nextTick(x => {
      if(this.isToday && this.index == 0) {
        this.$nextTick(x => this.$nextTick(x =>
          setTimeout(x => this.alphabetFilter(), 300)
        ))
      }
    }))
  },

  watch: {
    cell: {
      handler(nval) { this.determineType() },
      deep: true,
    }
  },

  computed: {
    reaction() {
      if (!this.is.product) return

      let list = this.productsService.reactions
      let id = this.cell.replaced_product ? this.cell.replaced_product.id : this.cell.product.id
      let has = (type, x) => list[type].findIndex(p => x == p.product.id) !== -1

      if (has('liked', id)) return 1
      if (has('disliked', id)) return 2
      if (has('allergic', id)) return 3
    }
  },

  methods: {
    determineType() {
      this.is.product = this.cell && this.cell.product !== null
      this.is.group = !this.is.product && this.cell && this.cell.product_group !== null
      this.is.empty = !this.is.product && !this.is.group
      this.is.hoverable = this.cell && ((this.is.product && !this.cell.product.is_internal) || this.is.group || this.is.empty)
    },

    deselect() {
      this.selected.alternative = false
      this.selected.product = false
      this.selected.group = false

      // this.alternatives = []
      // this.variants = []
      // this.replace = null
    },

    alphabetFilter() {
      let alphabet
      try {
        alphabet = this.$parent.$parent.$parent.$refs.alphabet.$refs.recommended
      } catch (e) {
        this.$nextTick(x => this.$nextTick(x =>
          setTimeout(x => this.alphabetFilter(), 100)
        ))

        return
      }

      if (this.is.product) alphabet.filter = { element: this.cell.replaced_product ? this.cell.replaced_product.id : this.cell.product.id }
      if (this.is.group) alphabet.filter = { group: this.cell.product_group.id }
      if (this.is.empty) alphabet.filter = {}
    },

    select(show=false) {
      if (!this.is.hoverable) return

      if (show) {
        this.alphabetFilter()
      }

      if (this.cell.date.getTime() < this.today.getTime()) return

      let deselector = e => {
        if ($(this.$el).find(e.target).length === 0) {
          this.deselect()
          $(document).off('click touchend', deselector)
        }
      }
      $(document).on('click touchend', deselector)

      if (this.is.product) {
        this.selected.alternative = true
        this.setLoading()

        this.productsService.getAlternatives(this.cell.product.id)
          .then(data => {
            this.alternatives = data
            this.unsetLoading()
          })
      }

      if (this.is.group) {
        this.selected.product = true
        this.setLoading()

        this.productsService.getVariants(this.cell.id)
          .then(data => {
            // if (data.is_groups) {
            //   this.selected.group = true
            //   this.selected.product = false
            // }

            this.variants = data.objects
            this.unsetLoading()
          })
      }

      if (this.is.empty) {
        this.selected.group = true
        this.setLoading()

        this.productsService.getVariants(this.cell.id)
          .then(data => {
            if (!data.is_groups && this.selected.group) {
              this.selected.group = false
              this.selected.product = true
            }

            this.variants = data.objects
            this.unsetLoading()
          })
      }
    },

    setProduct(product) {
      this.deselect()
      this.cell.product = product
      this.cell.product_group = null

      this.productsService.selectProduct(product.id, this.cell.id)
        .then(stage => this.stagesService.setStage(stage))
    },

    setGroup(group) {
      this.deselect()
      this.cell.product = null
      this.cell.product_group = group

      this.productsService.selectGroup(group.id, this.cell.id)
        .then(stage => this.stagesService.setStage(stage))
    },

    setReplace(id) {
      this.replace = id == this.replace ? null : id
    },

    confirmOpen(action) {
      let actionId = {
        like: 1,
        dislike: 2,
        allergic: 3
      }[action]
      if (this.reaction == actionId) return

      this.confirmIcon = `modal__icon--${actionId}`
      this.confirmTitle = this.i18n.reactionAction[
        `${action}_${this.reaction == actionId ? 'delete' : 'add'}`
      ]
      this.$refs.confirm.open()
      this.confirmSucceed = x => this[action]()
    },

    confirmClose() {
      this.unsetLoading()
      this.deselect()
      this.$refs.confirm.close()
    },

    confirmSucceed() {},

    like() {
      if (!this.is.product || this.reaction == 1 || !this.is.hoverable) return
      let id = this.cell.replaced_product ? this.cell.replaced_product.id : this.cell.product.id

      this.setLoading()
      this.productsService.like(id, this.cell.id)
        .then(stage => this.stagesService.setStage(stage))
        .then(x => this.confirmClose())
    },

    variantSelector(action) {
      this.replace = null
      this.variantConfirm = x => {
        this.$refs.confirm.close()
        this.$refs.replaceAlternatives.close()
        this[`${action}Confirmed`]()
      }

      if (this.index !== 0) {
        this.variantConfirm()
        return
      }

      this.$refs.confirm.close()
      this.$refs.loader.open()
      this.productsService.getVariants(this.cell.id)
        .then(data => {
          this.variants = data.objects
          this.$refs.loader.close()

          if (this.variants.length > 0) {
            this.$refs.replaceAlternatives.open()
            document.body.appendChild(this.$refs.replaceAlternatives.$el)
          } else {
            this.variantConfirm()
          }
        })
    },

    variantConfirm() {},

    dislike() {
      if (!this.is.product || this.reaction == 2 || !this.is.hoverable) return
      this.variantSelector('dislike')
    },

    dislikeConfirmed() {
      if (!this.is.product) return
      let id = this.cell.replaced_product ? this.cell.replaced_product.id : this.cell.product.id

      this.$refs.loader.open()
      this.productsService.dislike(
        id, this.cell.id, this.replace || ''
      )
        .then(stage => {
          this.stagesService.setStage(stage)
          this.$refs.loader.close()
        })
    },

    allergic() {
      if (!this.is.product || this.reaction == 3 || !this.is.hoverable) return
      this.variantSelector('allergic')
    },

    allergicConfirmed() {
      if (!this.is.product) return
      let id = this.cell.replaced_product ? this.cell.replaced_product.id : this.cell.product.id

      this.$refs.loader.open()
      this.productsService.allergy(
        id, this.cell.id, this.replace || ''
      )
        .then(stage => {
          if (stage.allergy_count > this.$parent.stage.allergy_count && stage.allergy_count == 2) {
            this.productsService.$emit('frequentAllergy')
          }

          this.stagesService.setStage(stage)
          this.$refs.loader.close()
        })
    },

    // allergic() {
    //   if (!this.is.product || this.reaction == 3) return

    //   this.setLoading()
    //   this.productsService.allergy(this.cell.product.id, this.cell.id)
    //     .then(stage => this.stagesService.setStage(stage))
    //     .then(x => this.confirmClose())
    // },
  }
}

</script>



// WEBPACK FOOTER //
// src/js/calendar/components/stage-cell.vue